<template>
  <v-card class="my-4">
    <v-card-title class="secondary py-1"
      >Grupos agregados en el periodo</v-card-title
    >
    <v-card-text v-if="!grupos" class="py-2"
      >No tiene grupos asignados para el semestre</v-card-text
    >
    <v-card-text class="py-0"
      ><v-row
        ><v-col
          cols="12"
          sm="6"
          md="4"
          xl="3"
          class="py-1"
          v-for="grupo in grupos"
          :key="grupo.id"
          >{{
            grupo.semestre +
            '&deg; "' +
            grupo.letra +
            '" ' +
            grupo.turno +
            " " +
            grupo.nombre +
            " (" +
            grupo.plan_estudios +
            ")"
          }}
        </v-col></v-row
      ></v-card-text
    ></v-card
  >
</template>

<script>
export default {
  name: "GrupoAgregados",

  props: {
    grupos: Object,
  },

  data: () => ({}),

  computed: {},

  methods: {},

  mounted() {},
};
</script>
